import JSBI from 'jsbi'
import { SolidityType, ChainId } from '../constants'
import { validateSolidityTypeInstance } from '../utils'
/**
 * A currency is any fungible financial instrument on Ethereum, including Ether and all ERC20 tokens.
 *
 * The only instance of the base class `Currency` is Ether.
 */
export class Currency {
  public readonly decimals: number
  public readonly symbol?: string
  public readonly name?: string

  /**
   * The only instance of the base class `Currency`.
   */
  public static readonly ETHER: Currency = new Currency(18, 'ETH', 'Ether')
  public static readonly AVAX: Currency = new Currency(18, 'AVAX', 'AVAX')
  public static readonly BNB: Currency = new Currency(18, 'BNB', 'BNB')
  public static readonly DEV: Currency = new Currency(18, 'DEV', 'DEV')
  public static readonly MATIC: Currency = new Currency(18, 'MATIC', 'MATIC')
  public static readonly HECO: Currency = new Currency(18, 'HT', 'HT')

  /**
   * Constructs an instance of the base class `Currency`. The only instance of the base class `Currency` is `Currency.ETHER`.
   * @param decimals decimals of the currency
   * @param symbol symbol of the currency
   * @param name of the currency
   */
  protected constructor(decimals: number, symbol?: string, name?: string) {
    validateSolidityTypeInstance(JSBI.BigInt(decimals), SolidityType.uint8)

    this.decimals = decimals
    this.symbol = symbol
    this.name = name
  }
}

export const ETHER = Currency.ETHER
export const AVAX = Currency.AVAX
export const BNB = Currency.BNB
export const DEV = Currency.DEV
export const MATIC = Currency.MATIC
export const HECO = Currency.HECO
export const ETHER_CURRENCIES = [ETHER, AVAX, BNB, DEV, MATIC, HECO];
export const ETHER_NAMES_CURRENCIES = ['ETH', 'AVAX', 'BNB', 'DEV', 'MATIC', 'HT'];

export const CHAIN_IDS_AND_CURRENCIES: ([ChainId, Currency])[] = [
  [ChainId.MAINNET, ETHER],
  [ChainId.ROPSTEN, ETHER],
  [ChainId.RINKEBY, ETHER],
  [ChainId.GÖRLI, ETHER],
  [ChainId.KOVAN, ETHER],
  [ChainId.FUJI, AVAX],
  [ChainId.AVALANCHE, AVAX],
  [ChainId.SMART_CHAIN, BNB],
  [ChainId.SMART_CHAIN_TEST, BNB],
  [ChainId.MOONBASE_ALPHA, DEV],
  [ChainId.MUMBAI, MATIC],
  [ChainId.MATIC, MATIC],
  [ChainId.HECO, HECO],
];
